import { getEnvironmentConfig, getEnvVariableDefault } from '../configHelper.js';
const definition = {
    base: {
        maxConcurrent: parseInt(getEnvVariableDefault('PRESSURE_MAX_CONCURRENT', '20')),
        maxEventLoopUtilization: parseFloat(getEnvVariableDefault('PRESSURE_MAX_ELU', '0.99')),
        maxHeapUsedBytes: parseInt(getEnvVariableDefault('PRESSURE_MAX_HEAP_BYTES', '0')),
        retryAfterSecs: parseInt(getEnvVariableDefault('PRESSURE_RETRY_AFTER_SECS', '30')),
    },
    local: {
        maxEventLoopUtilization: 1,
    },
    local_k8s: {
        maxEventLoopUtilization: 1,
    },
    local_e2e: {
        maxConcurrent: 40,
        maxEventLoopUtilization: 1,
    },
    test: {
        maxConcurrent: 40,
        maxEventLoopUtilization: 1,
    },
    development: {
        maxConcurrent: 40,
        maxEventLoopUtilization: 1,
    },
    sandbox: {
        maxConcurrent: 40,
        maxEventLoopUtilization: 1,
    },
};
/**
 * Load-shedding / back-pressure configuration for the renderer.
 *
 * The middleware returns **503 Service Unavailable** when any threshold is
 * exceeded, preventing the Node.js event loop from saturating under traffic
 * spikes (the "death spiral" scenario).
 *
 * **`maxConcurrent` rationale — per-worker, not per-pod:**
 * The renderer runs in Node.js cluster mode (1 worker per CPU).  Each worker
 * is a separate process with its own event loop and its own instance of the
 * middleware, so the limit applies **per worker**.
 *
 * - **Base (20)** — 20 concurrent SSR renders per worker is a realistic
 *   ceiling for a 1-vCPU worker doing 6-8 MongoDB queries per render.  The
 *   concurrency guard should trip before ELU saturates, preventing the stale
 *   ELU problem entirely.
 *
 * Override at runtime via `PRESSURE_MAX_CONCURRENT` without a redeploy.
 */
export const pressureConfig = () => getEnvironmentConfig(definition);
//# sourceMappingURL=pressure.config.js.map